import styled from 'styled-components';

const A = styled.a`
  ${({ href }) => !href && 'pointer-events: none'};
`;

const Styled = {
  A,
};

export default Styled;
